export const getVariationsFromURLParams = () => {
  const query = new URLSearchParams(window.location.search);

  const personalizations = query.get('personalizations') || '';

  return personalizations.split(',');
};
